// extracted by mini-css-extract-plugin
export var notificationHost = "_i7-0";